import { useMemo } from 'react';

export default function useMapStyles() {
  const LOCIQ = import.meta.env.VITE_LOCATIONIQ_KEY;

  return useMemo(() => {
    const styles = [];
    
    // OpenStreetMap
    styles.push({
      id: 'osm',
      name: 'OpenStreetMap',
      url: {
        version: 8,
        //glyphs: 'https://basemaps.cartocdn.com/gl/fonts/{fontstack}/{range}.pbf',
        glyphs: 'https://cdn.traccar.com/map/fonts/{fontstack}/{range}.pbf',
        sources: {
         'osm-tiles': {
            type: 'raster',
            tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
            tileSize: 256,
            attribution: '© OpenStreetMap contributors',
          },
        },
        layers: [
          {
            id: 'osm-tiles-layer',
            type: 'raster',
            source: 'osm-tiles',
            minzoom: 0,
            maxzoom: 19,
          },
        ],
      },
      available: true,
    });

    // Carto
    styles.push({
      id: 'carto-voyager',
      name: 'Carto',
      url: 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json',
      available: true,
      scheme: 'light',
    });

    // Carto Dark Matter — esquema de color oscuro (para distinguir mejor las
    // polylines de colores, estilo del tracking de la torre de control).
    styles.push({
      id: 'carto-dark',
      name: 'Oscuro',
      url: 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json',
      available: true,
      scheme: 'dark',
    });

    // LocationIQ 
    if (LOCIQ) {
      styles.unshift({
        id: 'locationiq-streets',
        name: 'LocationIQ Streets',
        url: `https://tiles.locationiq.com/v3/streets/vector.json?key=${LOCIQ}`,
        available: true,
      });
    }

    return styles;
  }, [LOCIQ]);
}
